import { render, staticRenderFns } from "./NsimRulesAdd.vue?vue&type=template&id=4c10f6ec&"
import script from "./NsimRulesAdd.vue?vue&type=script&lang=js&"
export * from "./NsimRulesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports